import React, { useEffect, useState } from "react";
import DateRangePicker from 'react-daterange-picker';
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import LargeRectangle from "../advertisements/LargeRectangle";
import BillBoard from "../advertisements/BillBoard";
import sty from '../listings/forms/addpost.module.css';
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import styles from './productpage.module.css'

const MartReport = (props) => {
    const { id } = useParams();
    const [orders, setOrders] = useState([]);
    const [totalNetTotalPrice, setTotalNetTotalPrice] = useState(0);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [dateRange, setDateRange] = useState(
        moment.range(moment().subtract(7, "days"), moment())
    );
    const [dateValue, setDateValue] = useState("");


    const renderDateValue = (range) => {
        const start = range.start.format("DD/MM/YYYY");
        const end = range.end.format("DD/MM/YYYY");

        return start === end ? start : `${start} - ${end}`;
    };

    const martReport = async (range) => {
        if (!range) return;

        const start = range.start.format("YYYY-MM-DD");
        const end = range.end.format("YYYY-MM-DD");

        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/report/${id}`,
                {
                    params: { startDate: start, endDate: end },
                }
            );
            setOrders(response.data.orders || []);
            setTotalNetTotalPrice(response.data.totalNetTotalPrice || 0);
        } catch (error) {
            console.error("Error fetching report:", error);
        }
    };

    // Initial load
    useEffect(() => {
        setDateValue(renderDateValue(dateRange));
        martReport(dateRange);
    }, []);

    // On date change
    const handleDateSelect = (range) => {
        setDateRange(range);
        setIsDatePickerOpen(false);
        setDateValue(renderDateValue(range));
        martReport(range);
    };

    return (
        <div className="admin-view-head">
            <div className="mt-4 g-2 col-md-12">
                <div className="col-md-2 add_button animated_back_button text-right">
                    <ButtonStyle type="button" className="form-control btn btn-block btn_font"
                        handleClick={() => props.history.goBack()}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
                </div>
                <h2 className={styles.productName}>Mart Report</h2>
                <div className="col-md-6 date_range_picker low_padding pb-4">

                    <div className="date_range_picker_input" onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}>
                        <i className="fa fa-calendar cal_icon" aria-hidden="true"></i>
                        <input
                            type="text"
                            className="form-control white_readonly"
                            id="date_search"
                            placeholder="Date Range"
                            value={dateValue}
                            readOnly
                        />
                    </div>

                    {isDatePickerOpen && (
                        <div className="date_picker position-absolute mt-2 z-10">
                            <DateRangePicker
                                value={dateRange}
                                onSelect={handleDateSelect}
                                singleDateRange={true}
                                maximumDate={new Date()}
                            />
                        </div>
                    )}
                </div>
                
                <div className="table-responsive">
                <div className="mt-4 font-semibold">
                    <h3>Total Net Price: <b> ₹{totalNetTotalPrice.toFixed(2)}</b></h3>
                </div><br />
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th >Order Number</th>
                                <th >Order Date</th>
                                <th >Status</th>
                                <th >Net Price</th>
                                <th >GST</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((order) => (
                                <tr key={order.orderNumber}>
                                    <td >{order.orderNumber}</td>
                                    <td >
                                        {new Date(order.orderDate).toLocaleString()}
                                    </td>
                                    <td >{order.orderStatus}</td>
                                    <td >{order.netTotalPrice}</td>
                                    <td >{order.totalGst}</td>
                                </tr>
                            ))}
                            {orders.length === 0 && (
                                <tr>
                                    <td colSpan="5" className=" text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={`listings row ${sty.large_rect}`}>
                {!props.isAdmin && <LargeRectangle spot={"-1"} />}
            </div>
            <div className={`${sty.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
                {!props.isAdmin && <BillBoard spot={"-1"} />}
            </div>
        </div>
    );
};

export default MartReport;
